/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { FormGroup, Label } from 'reactstrap';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { MessageFormUserMin } from '../types';
import { getFullName } from '@utils/user';

type UserSelectOption = { value: string; label: string };

interface UserSelectFieldProps {
  label?: string;
  onChange: (userIds: string[]) => void;
  userIds?: string[];
  users: MessageFormUserMin[];
}

export const UserSelectField = (props: UserSelectFieldProps) => {
  const { label = 'To', userIds, onChange, users } = props;

  const usersList: UserSelectOption[] = users.map((user) => ({ value: user._id, label: getFullName(user) }))

  return (
    <FormGroup>
      <Label for='users'>{label}</Label>
      <SelectFactory
        selectType={SelectTypes.MultipleSelect}
        className='dont_translate'
        placeholder={'Users'}
        options={usersList}
        noOptionsMessage='No users available for selection'
        values={userIds ?? []}
        onChange={(values: string[]) => onChange(values)}
      />
    </FormGroup>
  );
};
